import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header';
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import CardGrid from '../components/CardGrid';
import { AppContext } from '../context/AppContext';
import isPage from '../hoc/isPage';
import { getRoleID } from '../helpers';

class ReportsListingPage extends Component {
    static propTypes = {

        role: PropTypes.shape({
            roleID: PropTypes.string,
            role: PropTypes.string  // name of role
        }),

        // what mode is the page operating in?
        // options:
        //      reports (normalReports)
        //      admin >> admin reports (adminReports)
        mode: PropTypes.oneOf([
            "normalReports",
            "adminReports"
        ])
    }

    state = {
        reports: [],
    }

    handleChangeDealer = (e) => {

        const selectedReportOrg = e.target.value;

        // save this to session storage
        this.props.saveToSessionStorage('selectedReportOrg', selectedReportOrg);
        this.setState({ selectedReportOrg: selectedReportOrg })
        this.context.setState({selectedReportOrg: selectedReportOrg})
    }

    componentDidMount() {

        let apiUrl;

        switch (this.props.mode) {
            case "normalReports":
                apiUrl = '/api/portal/report/GetReportTypes?reportMode=normal';
                break;

            case "adminReports":
                // get the roleID of the super admin role
                const superAdminRoleID = getRoleID("superadmin");
                if (superAdminRoleID) {

                    // grab just the admin reports
                    apiUrl = `/api/portal/report/GetReportTypes?roleID=${superAdminRoleID}&reportMode=normal`;
                }
                else {
                    this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0377"))
                    return;
                }
                break;
            default:
                break;
        }

        this.props.getData(apiUrl).then(response => {
            //console.log(apiUrl)
            response.data.forEach(report => {

                let path;
                let linkParams;

                switch (this.props.mode) {
                    case "normalReports":
                        path = 'reports';
                        linkParams = "";
                        break;

                    case "adminReports":
                        // get the roleID of the super admin role
                        const superAdminRoleID = getRoleID("superadmin");
                        if (superAdminRoleID) {
                            // grab just the admin reports
                            path = 'admin/reports';
                            linkParams = "&roleID=572180F3-3F48-4523-B547-2B134FCB05CF&role=superadmin";
                        }
                        else {
                            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0377"))
                            return;
                        }
                        break;
                    default:
                        break;
                }

                // set properties appropriately so they can be fed into the Card Grid component
                report.id = report.reportID;
                report.label = report.reportName;
                report.link = `/${path}/${report.id}`;
                report.linkParams = `?reportTitle=${report.label}${linkParams}`;
            });

            this.setState({
                reports: response.data
            });
            //console.log(this.state.reports)

        }).catch(error => {
            this.props.errorAlert("m0378");
        });

        //const reports = orgReportsList[orgType];
    }

    render() {
        let title;

        switch (this.props.mode) {
            case "normalReports":
                title = this.props.returnLocalizedString("m0379");
                break;
            case "adminReports":
                title = this.props.returnLocalizedString("m0380");
                break;
            default:
                break;
        }
        const tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label={title} ></Tab>
        </Tabs>);

        return (
            <div>
                <Header title={title} tabs={tabs} >
                </Header>
                <section className="page-content grid-row pad-it">
                    <div className="grid-col m-col-12 no-left-pad">
                        <CardGrid type="reports" data={this.state.reports} />
                    </div>
                </section>
            </div>
        );
    }

}

ReportsListingPage.contextType = AppContext;
export default isPage(ReportsListingPage);


// WEBPACK FOOTER //
// ./src/containers/ReportsListingPage.js